<template>
  <div class="df fdc">
    <h2 class="nexa-font-bold ttc">Sign in to your account</h2>
    <input
      v-on:input="setLandingEmail()"
      v-model="email"
      class="input-landing input1 mb10"
      type="email"
      placeholder="Email Address"
    />
    <span class="show-password-wrapper">
      <input
        v-model="password"
        class="input-landing input1"
        v-bind:type="showPassword ? 'text' : 'password'"
        placeholder="Password"
      />
      <p class="show-password" v-on:click="togglePassword()">
        {{ showPassword ? "Hide" : "Show" }}
      </p>
    </span>
    <p class="forgot-password">
      <router-link :to="'/forgotPassword'">Forgot Password?</router-link>
    </p>
    <button class="button-landing nexa-font-bold ls05" v-on:click="login()">
      Log in
    </button>
    <div>
      <button
        v-on:click="googleSignin()"
        class="button-google button-landing ls05"
      >
        <img
          class="google-icon"
          src="/images/google-logo.png"
          alt=""
        />
        <p class="nexa-font-bold">Sign in with Google</p>
      </button>
    </div>
    <p
      v-if="$store.getters.authError"
      class="login-register-error animated fadeIn"
    >
      {{ $store.getters.authError }}
    </p>
    <p class="account-caption">
      Don't have an account?
      <router-link :to="'/register'">Sign up</router-link>
    </p>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      showPassword: false
    };
  },
  props: ["landingEmail"],
  components: {},
  methods: {
    setLandingEmail() {
      this.$emit("setLandingEmail", { landingEmail: this.email });
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    login() {
      this.$store.dispatch("clearAuthError", {});
      // if (this.$refs.form.validate()) {
      this.$store.dispatch("login", {
        email: this.email,
        password: this.password
      });
    },
    googleSignin() {
      this.$store.dispatch("googleLogin", {});
    }
  },
  computed: {},
  created() {
    if (this.$route.query.redirect) {
      this.$store.dispatch("setRedirectUrl", this.$route.query.redirect);
    }
    this.landingEmail ? (this.email = this.landingEmail) : null;

    document.onkeydown = checkKey;
    var _this = this;
    this.$store.dispatch("clearAuthError", {});
    function checkKey(e) {
      e = e || window.event;
      if (e.keyCode == "13") {
        e.preventDefault();
        _this.login();
      }
    }
  },
  beforeDestroy() {
    document.onkeydown = null;
  }
};
</script>

<style scoped lang="scss">
h2 {
  color: black;
  font-weight: 500;
  margin-bottom: 30px;
  align-self: center;

  // Responsive Style
  // @media max-width: 768px
  @media (max-width: 768px) {
    font-size: 16px;
  }
}

.button-google {
  margin-top: 10px;
  background: #f5f5f5;
  color: #303030;
  display: flex;
  justify-content: center;
  align-items: center;
}

.google-icon {
  margin-right: 10px;
}

.forgot-password {
  color: #5558ff;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 30px;

  a {
    color: #5558ff;
    text-decoration: none;
    font-family: "GG";
  }
}

.show-password-wrapper {
  position: relative;
}

.show-password {
  position: absolute;
  right: 8px;
  top: 8px;
  color: #5558ff;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.21px;
  line-height: 14px;
  cursor: pointer;
  font-family: "GG";
  font-weight: 400;
}

.account-caption {
  margin-top: 10px !important;
  a {
    font-family: "GG";
    color: #5558ff;
    text-decoration: none;
    font-weight: 500;
    cursor: pointer;
  }
}
</style>
